import DateText from './DateText';

export default DateText;
